import React from 'react';
import './SessionTemplates.css';

const SessionTemplates = ({ onTemplateSelect }) => {
  const templates = [
    {
      id: 'competitive-analysis',
      name: 'Competitive Analysis',
      description: 'Compare multiple brands side-by-side to understand market positioning and strategy differences',
      icon: '🏆',
      suggestedBrands: ['Nike', 'Adidas', 'Under Armour'],
      dateRange: {
        start: '2023-01-01',
        end: '2023-12-31'
      },
      useAllTime: false,
      researchNotes: 'Focus on psychological triggers, email frequency, and campaign types. Look for dominant strategies and market positioning.'
    },
    {
      id: 'seasonal-campaign-study',
      name: 'Seasonal Campaign Study',
      description: 'Analyze holiday and seasonal email marketing patterns across multiple years',
      icon: '🎄',
      suggestedBrands: ['Target', 'Walmart', 'Amazon'],
      dateRange: {
        start: '2022-11-01',
        end: '2023-01-31'
      },
      useAllTime: false,
      researchNotes: 'Study Black Friday, Cyber Monday, and holiday season patterns. Compare volume, timing, and psychological triggers.'
    },
    {
      id: 'brand-deep-dive',
      name: 'Brand Deep Dive',
      description: 'Comprehensive analysis of a single brand\'s email marketing strategy evolution',
      icon: '🔍',
      suggestedBrands: ['J.Crew'],
      dateRange: null,
      useAllTime: true,
      researchNotes: 'Analyze strategy evolution over time. Look for changes in psychological triggers, campaign types, and email frequency.'
    },
    {
      id: 'fashion-retail-comparison',
      name: 'Fashion Retail Comparison',
      description: 'Compare fashion retailers to understand industry trends and competitive positioning',
      icon: '👗',
      suggestedBrands: ['Zara', 'H&M', 'Uniqlo', 'Gap'],
      dateRange: {
        start: '2023-06-01',
        end: '2023-12-31'
      },
      useAllTime: false,
      researchNotes: 'Focus on seasonal trends, psychological triggers, and campaign frequency. Look for industry patterns.'
    },
    {
      id: 'tech-email-strategies',
      name: 'Tech Email Strategies',
      description: 'Analyze technology companies\' email marketing approaches and psychological triggers',
      icon: '💻',
      suggestedBrands: ['Apple', 'Google', 'Microsoft', 'Samsung'],
      dateRange: {
        start: '2023-01-01',
        end: '2023-12-31'
      },
      useAllTime: false,
      researchNotes: 'Compare authority-based vs. urgency-based approaches. Analyze product launch campaigns and customer retention strategies.'
    },
    {
      id: 'luxury-brand-analysis',
      name: 'Luxury Brand Analysis',
      description: 'Study luxury brands\' email marketing strategies and psychological positioning',
      icon: '💎',
      suggestedBrands: ['Louis Vuitton', 'Gucci', 'Chanel', 'Hermès'],
      dateRange: {
        start: '2023-01-01',
        end: '2023-12-31'
      },
      useAllTime: false,
      researchNotes: 'Focus on authority and social proof triggers. Analyze exclusivity messaging and brand positioning.'
    }
  ];

  const handleTemplateSelect = (template) => {
    onTemplateSelect(template);
  };

  return (
    <div className="session-templates">
      <h3>Research Templates</h3>
      <p className="templates-description">
        Choose from pre-built research scenarios to jumpstart your analysis
      </p>
      
      <div className="templates-grid">
        {templates.map((template) => (
          <div 
            key={template.id} 
            className="template-card"
            onClick={() => handleTemplateSelect(template)}
          >
            <div className="template-header">
              <span className="template-icon">{template.icon}</span>
              <h4 className="template-name">{template.name}</h4>
            </div>
            
            <p className="template-description">{template.description}</p>
            
            <div className="template-details">
              <div className="template-brands">
                <strong>Suggested Brands:</strong>
                <div className="brand-tags">
                  {template.suggestedBrands.map((brand, index) => (
                    <span key={index} className="brand-tag">{brand}</span>
                  ))}
                </div>
              </div>
              
              <div className="template-date-range">
                <strong>Date Range:</strong>
                <span>
                  {template.useAllTime 
                    ? 'All Time' 
                    : `${template.dateRange.start} to ${template.dateRange.end}`
                  }
                </span>
              </div>
            </div>
            
            <div className="template-notes">
              <strong>Research Focus:</strong>
              <p>{template.researchNotes}</p>
            </div>
            
            <button className="use-template-btn">
              Use This Template
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionTemplates;
